import React from 'react';
import { closeModal, showModal } from 'lib/components/Modal';
import Dialog from '../DialogV2';
import './index.scss';

interface TipsDialogProps {
  title?: string;
  content?: string | React.ReactNode;
  buttonText?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  closeModal?: () => void;
  customClass?: string;
}

const TipsDialog = ({
  title = '温馨提醒',
  content,
  buttonText = '我知道了',
  onConfirm,
  onClose,
  closeModal,
}: TipsDialogProps) => {
  const handleConfirm = () => {
    closeModal?.();
    onConfirm?.();
  };

  const handleClose = () => {
    closeModal?.();
    onClose?.();
  };

  return (
    <Dialog
      title={title}
      customClass="common-tips-modal"
      closeCallback={onClose}
      keyboard={{ onEnter: handleConfirm, onEscape: handleClose }}
    >
      <div className="common-tips-modal__content">
        {typeof content === 'string' ? <div className="common-tips-modal__content-text">{content}</div> : content}
        <div className="common-tips-modal__content-confirm-button" onClick={handleConfirm}>
          {buttonText}
        </div>
      </div>
    </Dialog>
  );
};

export const showTipsDialog = (params: Omit<TipsDialogProps, 'closeModal'>) =>
  showModal(<TipsDialog {...params} closeModal={closeModal} />);

export default TipsDialog;
